import { Flex, Loader } from '@mantine/core';
import { Providers } from 'app/Providers';
import { Router } from 'app/Router';
import { Suspense } from 'react';

export const App = () => (
  <Providers>
    <Suspense
      fallback={
        <Flex w="100%" h="100%" justify="center" align="center">
          <Loader />
        </Flex>
      }
    >
      <Router />
    </Suspense>
  </Providers>
);
